import React from "react";
import { MonthFilters } from "./MonthFilters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./monthHelpers";
import { mapFilterValuesToInstructionExternal, mapResponseToFilterValuesExternal } from "./monthHelpersExternal";
import { PlanningTemplate } from "./PlanningTemplate";
import { MonthNavigationFilter } from "components/filters/components/MonthNavigationFilter";
import { useLoaderData } from "react-router";
import FlightApp from "flights/new/app";
import TrainModal from "train/TrainModal";

const PlanningMonthInternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MonthViewForInternalFrontModel>();

  return <>
    <FlightApp />
    <TrainModal />
    <PlanningTemplate
      filterSet="planning_Month"
      initialInstruction={viewModel.initialInstruction}
      defaultFilters={viewModel.defaultFilters}
      fetchFunction={window.CoreApi.Planning.PlanningByMonthForInternal}
      mapFilterValuesToInstruction={mapFilterValuesToInstruction}
      mapResponseToFilterValues={mapResponseToFilterValues}
      filterComp={<MonthFilters />}
      paginationComp={<MonthNavigationFilter />}
      maxEntriesPerColumn={5}
      filterPreset={{
        mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForPlanningByMonth,
        listApi: window.CoreApi.FilterPreset.ListFilterPresetsForPlanningByMonth
      }}
    />
  </>
};

const PlanningMonthExternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MonthViewForExternalFrontModel>();

  return <>
    <FlightApp />
    <TrainModal />
    <PlanningTemplate
      filterSet="planning_Month"
      initialInstruction={viewModel.initialInstruction}
      defaultFilters={viewModel.defaultFilters}
      fetchFunction={window.CoreApi.Planning.PlanningByMonthForExternal}
      mapFilterValuesToInstruction={mapFilterValuesToInstructionExternal}
      mapResponseToFilterValues={mapResponseToFilterValuesExternal}
      filterComp={<MonthFilters external />}
      paginationComp={<MonthNavigationFilter />}
      maxEntriesPerColumn={5}
    />
  </>
};

export const PlanningMonthApp = () => {
  if (site.currentEnvironment.type === "internal") {
    return <PlanningMonthInternalApp />;
  } else {
    return <PlanningMonthExternalApp />;
  }
}